import TopProducts, { TopProductsProps, TopProductItemProps } from './TopProducts'

export default TopProducts

export { TopProductsProps, TopProducts, TopProductItemProps }
